import { render, staticRenderFns } from "./OldNewSysSel_prepress.vue?vue&type=template&id=679fa5aa&"
import script from "./OldNewSysSel_prepress.vue?vue&type=script&lang=js&"
export * from "./OldNewSysSel_prepress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports